import fetchClient from './fetch-client'

const baseUrl = '/tasks'

function custom(url, body = {}, options = {}) {
  return fetchClient(`${baseUrl}${url}`, { body, ...options })
}

export { custom }
